// extracted by mini-css-extract-plugin
export default {"flex":"Validations_flex__vcHLc"};